import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/aggregation_user_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). The resource
// declares NO attributes and NO relationships — JR emits only id+type, so this
// registers an empty fields array.
const AggregationUserSchema = withDefaults({
  type: 'aggregation-user',
  fields: [],
});

export default AggregationUserSchema;
